<template>
  <div class="apply-return">
    <div class="goodsStyle acea-row row-between" v-for="(item,key) in goodsList" :key="key" >
      <div class="pictrue">
        <img :src="item.cart_info.productInfo.image" class="image" />
      </div>
      <div class="text acea-row row-between">
        <div class="name line2">
    		<p>{{ item.cart_info.productInfo.store_name }}</p>
    		<p v-if="item.cart_info.productInfo.attrInfo">{{ item.cart_info.productInfo.attrInfo.suk }}</p>
    		<p v-if="item.cart_info.spec_values">{{ item.cart_info.spec_values }}</p>
    	</div>
        <div class="money">
          <div>￥{{ item.cart_info.truePrice }}</div>
          <div class="num">x {{ item.cart_info.cart_num }}</div>
        </div>
      </div>
    </div>
    <div class="list">
      <div class="item acea-row row-between-wrapper">
        <div>售后方式</div>
        <div class="num">换货</div>
      </div>
      <div class="item acea-row row-between-wrapper">
        <div>换货原因</div>
        <div class="num acea-row row-left">
          <select v-model="reason">
            <option value="">请选择</option>
            <option
              v-for="(text, index) in reasonList"
              :value="text"
              :key="index"
            >
              {{ text }}
            </option>
          </select>
          <span class="iconfont icon-jiantou"></span>
        </div>
      </div>
	  <div class="h"></div>
	  <div class="item acea-row row-between-wrapper">
	    <div>换货数量</div>
		<div>
			<span @click="cut()" class="refund-num-cut">-</span>
			<input class="refund-num-input" type="number" v-model="refund_num" @keyup="keyupNum(cart_num)">
			<span @click="add(cart_num)" class="refund-num-add">+</span>
		</div>
	  </div>
	  <div class="h"></div>
	  <div class="item acea-row row-between-wrapper">
        <div>手机号码</div>
        <div class="num">
        	<input type="number" v-model="user_phone" pattern="[0-9]*" placeholder="请输入手机号码" >
        </div>
      </div>
	  <div class="item textarea acea-row row-between">
        <div>退款说明</div>
        <textarea
          placeholder="选填，最多100字"
          class="num"
          v-model="refund_reason_wap_explain"
		  maxlength="100"
        ></textarea>
      </div>
      <div class="item acea-row row-between">
        <div class="title acea-row row-between-wrapper">
          <div>上传凭证</div>
          <div class="tip">( 最多可上传3张 )</div>
        </div>
        <div class="upload acea-row row-middle">
          <div
            class="pictrue"
            v-for="(img, index) in refund_reason_wap_img"
            :key="index"
          >
            <img :src="img" />
            <div
              class="iconfont icon-guanbi1 font-color-red"
              @click="refund_reason_wap_img.splice(index, 1)"
            ></div>
          </div>
          <VueCoreImageUpload
            class="btn btn-primary"
            :crop="false"
            compress="80"
            @imageuploaded="imageuploaded"
            :headers="headers"
            :max-file-size="5242880"
            :credentials="false"
            inputAccept="image/*"
            inputOfFile="file"
            :url="url"
            v-if="refund_reason_wap_img.length < 3"
          >
            <div class="pictrue acea-row row-center-wrapper row-column">
              <span class="iconfont icon-icon25201"></span>
              <div>上传凭证</div>
            </div>
          </VueCoreImageUpload>
        </div>
      </div>
    </div>
    <button type="button" class="returnBnt bg-color-red displayblock" @click="submit" :disabled="isDisabled">申请换货</button>
  </div>
</template>

<script>
import { RefundReason, OrderRefund, getRefundGoods } from "@api/order";
import { trim, VUE_APP_API_URL } from "@utils";
import VueCoreImageUpload from "vue-core-image-upload";

export default {
  name: "ExchangeGoods",
  components: {
    VueCoreImageUpload
  },
  data() {
    return {
	  goodsList: [],
	  refund_amount:"",
	  coupon_price:"",
	  user_phone:"",
      url: `${VUE_APP_API_URL}/upload/image`,
      headers: {
        "Authori-zation": "Bearer " + this.$store.state.app.token
      },
      id: this.$route.params.id || 0,
      reasonList: [],
	  refund_num:"",
	  refund_money:"",
      reason: "",
      refund_reason_wap_explain: "",
      refund_reason_wap_img: [],
      isDisabled:false
    };
  },
  watch: {
    $route(n) {
      if(n.name == 'ExchangeGoods'){this.getRefundGoods();}
    }
  },
  mounted() {
    this.getRefundGoods();
    this.getRefundReason();
  },
  methods: {
	//商品详情
	getRefundGoods(){
		let that = this;
		let unique = that.$route.params.id;
		getRefundGoods(unique).then(res => {
			that.goodsList = res.data.cartInfo;
			that.refund_num = res.data.cart_num;
			that.refund_amount = parseFloat(res.data.refund_amount);
			that.coupon_price = res.data.coupon_price;
			that.refund_money = res.data.refund_amount;
			that.user_phone = res.data.user_phone;
		}).catch(err => {
			that.$dialog.error(err.msg);
			setTimeout(function(){
				that.$router.go(-1);
			},1000)
		});
	},
	cut(){
		if(this.refund_num > 1){
			this.refund_num--;
		}else{
			this.$dialog.toast({mes:'数量不能小于1'});
		}
	},
	add(max){
		if(this.refund_num < max){
			this.refund_num++;
		}else{
			this.$dialog.toast({mes:'数量不能大于购买数量'});
		}
	},
	keyupNum(max){
		let keynum = parseInt(this.refund_num);
		if(keynum > max){
			this.refund_num = max;
			this.$dialog.toast({mes:'数量不能大于购买数量'});
		}
		if(keynum < 1){
			this.refund_num = max;
			this.$dialog.toast({mes:'数量不能小于1'});
		}
	},
    imageuploaded(res) {
      if (res.status !== 200)
        return this.$dialog.error(res.msg || "上传图片失败");
      this.refund_reason_wap_img.push(res.data.url);
    },
	//换货原因
    getRefundReason() {
      RefundReason(3).then(res => {
        this.reasonList = res.data;
      });
    },
    submit() {
	  let that =this;
	  const refund_reason_wap_explain = trim(that.refund_reason_wap_explain);
	  if (!that.reason) return that.$dialog.toast({ mes: "请选择换货原因" });
    that.isDisabled  = true;
      OrderRefund({
        unique: that.$route.params.id,
        refunds_type: 3,
        refunds_num: that.refund_num,
        refunds_reason_wap: that.reason,
        refunds_explain: refund_reason_wap_explain,
        refunds_voucher: that.refund_reason_wap_img.join(","),
        user_phone: that.user_phone
      })
        .then(res => {
          that.$dialog.success(res.msg);
          that.$router.push('/order/refund_status/' + that.$route.params.id);
        })
        .catch(res => {
          that.isDisabled  = false;
          that.$dialog.error(res.msg);
        });
    }
  },
  
};
</script>
<style scoped>
.line2 {
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.h{background-color: #f5f5f5;width: 100%;padding: 0.09rem 0 0.09rem 0.3rem;color: #999;font-size: 0.26rem;}
.refund-num{width: 80%;color: #ed1c1f;}
.refund-num input{color: #ed1c1f;}
.refund-num-cut,.refund-num-add{display: inline-block;background-color: #f6f7f9;padding: 0.1rem 0.2rem;}
.refund-num-input{background-color: #f2f3f5;width: 0.9rem;padding: 0.1rem 0;text-align: center;margin: 0 0.05rem;}
.num input{text-align: right;}
</style>
